import {
    CREATE_KNITTING_DC_FAILURE_DK,
    CREATE_KNITTING_DC_REQUEST_DK,
    CREATE_KNITTING_DC_SUCCESS_DK,
    CREATE_USER_FORM_KNITTING_DC_DK,
    FETCH_SINGLE_KNITTING_DC_FAILURE_DK,
    FETCH_SINGLE_KNITTING_DC_REQUEST_DK,
    FETCH_SINGLE_KNITTING_DC_SUCCESS_DK,
    FETCH_KNITTING_DC_FAILURE_DK,
    FETCH_KNITTING_DC_REQUEST_DK,
    FETCH_KNITTING_DC_SUCCESS_DK,
    NAVIGATE_KNITTING_DC_DETAILS_DK,
    NAVIGATE_KNITTING_DC_DK,
    KNITTING_DC_USERFORM_RESET_DK,
    UPDATE_KNITTING_DC_FAILURE_DK,
    UPDATE_KNITTING_DC_REQUEST_DK,
    UPDATE_KNITTING_DC_SUCCESS_DK,
    DELETE_KNITTING_DC_REQUEST_DK,
    DELETE_KNITTING_DC_SUCCESS_DK,
    DELETE_KNITTING_DC_FAILURE_DK,
    KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_YARN_PO_IN_KNITTING_DC_REQUEST_DK,
    FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS_DK,
    FETCH_YARN_PO_IN_KNITTING_DC_FAILURE_DK,
    FETCH_KNITTING_DC_INVOICE_REQUEST,
    FETCH_KNITTING_DC_INVOICE_SUCCESS,
    FETCH_KNITTING_DC_INVOICE_FAILURE,
    RESET_KNITTING_DC_INVOICE
} from './knittingDC.actionsType';

export const KNITTING_DC_DK = 'knittingDCDK';

let initialState = {
    loading: false,
    knittingDC: [],
    yarnPOInKnittingDC: [],
    knittingDCInvoice: [],

    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isKnittingDC: false,
    knittingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let knittingDCDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_DC_REQUEST_DK:
        case FETCH_YARN_PO_IN_KNITTING_DC_REQUEST_DK:
        case CREATE_KNITTING_DC_REQUEST_DK:
        case FETCH_KNITTING_DC_INVOICE_REQUEST:
        case FETCH_SINGLE_KNITTING_DC_REQUEST_DK:
        case UPDATE_KNITTING_DC_REQUEST_DK:
        case DELETE_KNITTING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingDC: updatePayload
            };
        case FETCH_KNITTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingDCInvoice: updatePayload
            };
        case FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPOInKnittingDC: updatePayload?.PONO
            };
        case CREATE_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case UPDATE_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_KNITTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_KNITTING_DC_FAILURE_DK:
        case FETCH_YARN_PO_IN_KNITTING_DC_FAILURE_DK:
        case FETCH_SINGLE_KNITTING_DC_FAILURE_DK:
        case CREATE_KNITTING_DC_FAILURE_DK:
        case UPDATE_KNITTING_DC_FAILURE_DK:
        case DELETE_KNITTING_DC_FAILURE_DK:
        case FETCH_KNITTING_DC_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case KNITTING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_KNITTING_DC_DETAILS_DK:
            return {
                ...state,
                isKnittingDC: true,
                knittingDCSelectedValue: updatePayload.knittingDCSelectedValue
            };
        case NAVIGATE_KNITTING_DC_DK:
            return {
                ...state,
                isKnittingDC: false
            };
        case RESET_KNITTING_DC_INVOICE:
            return {
                ...state,
                knittingDCInvoice: []
            };
        case KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
